import { Ciudad } from '../tipo/ciudad.class';


export class DireccionCliente {


    correspondenciaElectronica: boolean;
    correspondenciaFisica: boolean;
    municipio: String;
    correoElectronico: String;
    direccion: String;
    telefono: String;
    tipoDireccion: String;
    pais: Number;
    departamento: String;


    constructor() { }

}



// WEBPACK FOOTER //
// ./src/app/models/cliente/direccion-cliente.class.ts